export class CommonConstants {
  //Add filter
  public conditionTypeText: string[] = ["=="];
  public conditionTypeValues: string[] = ["==", ">=", "<="];
}

export enum FilterFieldTypes {
  text = "text",
  values = "values"
}
